import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  showIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer text-center leading-tight';
  const variants = {
    primary: 'bg-gradient-to-r from-amber-500 to-amber-600 hover:from-amber-400 hover:to-amber-500 text-white shadow-[0_4px_14px_0_rgba(245,158,11,0.39)] hover:shadow-[0_6px_20px_rgba(245,158,11,0.23)] hover:-translate-y-0.5 border border-amber-400/20',
    secondary: 'bg-stone-800 hover:bg-stone-900 text-white shadow-md hover:shadow-lg focus:ring-stone-800',
    outline: 'bg-transparent border-2 border-amber-600 text-amber-700 hover:bg-amber-50 focus:ring-amber-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-8 sm:px-12 py-4 sm:py-5 text-lg sm:text-xl w-full sm:w-auto min-h-[60px]'
  };
  return <a href="https://www.voicesoffreedomus.com/cart/45604499587258:1" target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-384">
      <span className="flex-1" data-id="element-385">{children}</span>
      {showIcon && <ArrowRight className="ml-3 h-5 w-5 flex-shrink-0" data-id="element-386" />}
    </a>;
}